/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './hardware-entities.scss';

/*@ngInject*/
export default function HardwareEntitiesController($translate, $mdDialog, toast, types, gatewayService, gatewayModelService, gatewayGroupService,
                                                   providerService, deviceService, deviceModelService, customerService, deviceGroupService) {
    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.entityStateText = '';
        vm.gatewayInputMac = '';
        vm.gatewayEntity = {};
        vm.deviceInputEui = '';
        vm.deviceEntity = {};

        vm.getGatewayByMac = getGatewayByMac;
        vm.getDeviceByEui = getDeviceByEui;
        vm.deleteGateway = deleteGateway;
        vm.deleteDevice = deleteDevice;
        vm.searchIfEnterPressed = searchIfEnterPressed;
    };

    function getGatewayByMac() {
        if (vm.gatewayInputMac) {
            var gatewayPromise = gatewayService.getSystemGatewayByMac(vm.gatewayInputMac);
            if (gatewayPromise) {
                gatewayPromise.then(
                    (gateway) => {
                        if (!angular.equals('', gateway)) {
                            vm.entityStateText = '';

                            vm.gatewayEntity.id = gateway.id.id;
                            vm.gatewayEntity.name = gateway.name;
                            vm.gatewayEntity.mac = gateway.mac;
                            vm.gatewayEntity.customerName = gateway.customerTitle;
                            if (gateway.gatewayModelId) {
                                getGatewayModelName(gateway.gatewayModelId.id);
                            }
                            if (gateway.gatewayGroupId) {
                                getGatewayGroupName(gateway.gatewayGroupId.id);
                            }
                            if (gateway.providerId) {
                                getProviderName(gateway.providerId.id);
                            }
                        } else {
                            resetEntityState($translate.instant('hardware-entities.gateway-not-found-text', {mac: vm.gatewayInputMac}));
                        }
                    },
                    () => {
                        resetEntityState($translate.instant('hardware-entities.gateway-not-found-text', {mac: vm.gatewayInputMac}));
                    });
            }
        } else {
            toast.showError($translate.instant('hardware-entities.enter-valid-gateway-id-text'));
        }
    }

    function deleteGateway($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title($translate.instant('gateway.delete-gateway-title', {name: vm.gatewayEntity.name}))
            .htmlContent($translate.instant('gateway.delete-gateway-text'))
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
                gatewayService.deleteSystemGateway(vm.gatewayEntity.id).then(function success() {
                    vm.gatewayInputMac = '';
                    resetEntityState($translate.instant('hardware-entities.gateway-was-deleted', {mac: vm.gatewayEntity.mac}));
                })
            },
            function () {
            })
    }

    function getGatewayModelName(gatewayModelId) {
        if (gatewayModelId) {
            var gatewayModelPromise = gatewayModelService.getSystemGatewayModel(gatewayModelId);
            if (gatewayModelPromise) {
                gatewayModelPromise.then(
                    (gatewayModel) => {
                        vm.gatewayEntity.modelName = gatewayModel.name;
                    },
                    () => {
                        vm.gatewayEntity.modelName = '';
                    }
                );
            }
        } else {
            vm.gatewayEntity.modelName = '';
        }
    }

    function getGatewayGroupName(gatewayGroupName) {
        if (gatewayGroupName) {
            var gatewayGroupPromise = gatewayGroupService.getSystemGatewayGroup(gatewayGroupName);
            if (gatewayGroupPromise) {
                gatewayGroupPromise.then(
                    (gatewayGroup) => {
                        vm.gatewayEntity.groupName = gatewayGroup.name;
                    },
                    () => {
                        vm.gatewayEntity.groupName = '';
                    }
                );
            }
        } else {
            vm.gatewayEntity.groupName = '';
        }
    }

    function getProviderName(providerId) {
        if (providerId) {
            var providerServicePromise = providerService.getProvider(providerId);
            if (providerServicePromise) {
                providerServicePromise.then(
                    (provider) => {
                        vm.gatewayEntity.providerName = provider.name;
                        vm.deviceEntity.providerName = provider.name;
                    },
                    () => {
                        vm.gatewayEntity.providerName = '';
                        vm.deviceEntity.providerName = '';
                    }
                );
            }
        } else {
            vm.gatewayEntity.providerName = '';
            vm.deviceEntity.providerName = '';
        }
    }

    function getDeviceByEui() {
        if (vm.deviceInputEui) {
            var devicePromise = deviceService.getSystemDeviceByEui(vm.deviceInputEui);
            if (devicePromise) {
                devicePromise.then(
                    (device) => {
                        if (!angular.equals('', device)) {
                            vm.entityStateText = '';

                            vm.deviceEntity.id = device.id.id;
                            vm.deviceEntity.name = device.name;
                            vm.deviceEntity.eui = device.deviceEUI;
                            if (device.deviceModelId) {
                                getDeviceModelName(device.deviceModelId.id);
                            }
                            if (device.providerId) {
                                getProviderName(device.providerId.id);
                            }
                            if (device.customerId) {
                                getCustomerName(device.customerId.id);
                            }
                            if (device.applicationId) {
                                getDeviceGroupName(device.applicationId.id);
                            }
                        } else {
                            resetEntityState($translate.instant('hardware-entities.device-not-found-text', {eui: vm.deviceInputEui}));
                        }
                    },
                    () => {
                        resetEntityState($translate.instant('hardware-entities.device-not-found-text', {eui: vm.deviceInputEui}));
                    });
            }
        } else {
            toast.showError($translate.instant('hardware-entities.enter-valid-device-eui-text'));
        }
    }

    function deleteDevice($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title($translate.instant('device.delete-device-title', {name: vm.deviceEntity.name}))
            .htmlContent($translate.instant('device.delete-device-text'))
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
                deviceService.deleteSystemDevice(vm.deviceEntity.id).then(function success() {
                    vm.deviceInputEui = '';
                    resetEntityState($translate.instant('hardware-entities.device-was-deleted', {eui: vm.deviceEntity.eui}));
                })
            },
            function () {
            })
    }

    function getDeviceModelName(deviceModelId) {
        if (deviceModelId) {
            var deviceModelServicePromise = deviceModelService.getSystemDeviceModel(deviceModelId);
            if (deviceModelServicePromise) {
                deviceModelServicePromise.then(
                    (deviceModel) => {
                        vm.deviceEntity.modelName = deviceModel.name;
                    },
                    () => {
                        vm.deviceEntity.modelName = '';
                    }
                );
            }
        } else {
            vm.deviceEntity.modelName = '';
        }
    }

    function getCustomerName(customerId) {
        if (customerId) {
            var customerServicePromise = customerService.getSystemCustomer(customerId);
            if (customerServicePromise) {
                customerServicePromise.then(
                    (customer) => {
                        vm.deviceEntity.customerName = customer.name;
                    },
                    () => {
                        vm.deviceEntity.customerName = '';
                    }
                );
            }
        } else {
            vm.deviceEntity.customerName = '';
        }
    }

    function getDeviceGroupName(applicationId) {
        if (applicationId) {
            var deviceGroupServicePromise = deviceGroupService.getSystemDeviceGroup(applicationId);
            if (deviceGroupServicePromise) {
                deviceGroupServicePromise.then(
                    (deviceGroup) => {
                        vm.deviceEntity.applicationName = deviceGroup.name;
                    },
                    () => {
                        vm.deviceEntity.applicationName = '';
                    }
                );
            }
        } else {
            vm.deviceEntity.applicationName = '';
        }
    }

    function resetEntityState(stateText) {
        vm.entityStateText = stateText;
        vm.gatewayEntity = {};
        vm.deviceEntity = {};
    }

    function searchIfEnterPressed(event, entity) {
        if (event.which === 13) {
            switch (entity) {
                case types.entityType.device:
                    getDeviceByEui(); break;
                case types.entityType.gateway:
                    getGatewayByMac(); break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/hardware-entities/hardware-entities.controller.js